import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import Joyride from 'react-joyride';
import { useSelector } from 'react-redux';
import Car from '../assets/images/car.png';
import CarWhite from '../assets/images/car-white.png';
import Moto from '../assets/images/moto.png';
import MotoWhite from '../assets/images/moto-white.png';
import Truck from '../assets/images/truck.png';
import TruckWhite from '../assets/images/truck-white.png';
import Professional from '../assets/images/professional.png';
import ProfessionalWhite from '../assets/images/professional-white.png';
import TripsWhite from '../assets/images/trips-white.png';
import Trips from '../assets/images/trips.png';
import ProductCard from '../common/components/ProductCard';
import AiProducts from './AiGenerateProducts/AiProducts';
import StorageService from '../services/StorageService';
import JobImage from '../assets/images/job.png';
import Doctors from '../assets/images/Doctors.png';
import Salute from '../assets/images/Salute.png';
import PubblicoImpiego from '../assets/images/pubblico-impiego.png';
import Stranieri from '../assets/images/Stranieri.png';
import Infortunio from '../assets/images/infortunio-icon.png';
import SearchIcon from '../assets/images/search.png';

// import { useTourContext } from '../context/useTourContext';
import HomeWhite from '../assets/images/home-white.png';
import Malattia from '../assets/images/malattia-icon.png';
import Home from '../assets/images/home.png';
import AncillariAuto from '../assets/images/ancillari-auto.png';
// import Luce from '../assets/images/luce.png';
import commercialImage from '../assets/images/commercial.png';
import commercialImageWhite from '../assets/images/commercial_white.png';
import condominio from '../assets/images/condominio-icon.png';
import rcFamiglia from '../assets/images/rc-famiglia.png';
import FideiussioniCauzioni from '../assets/images/surety-bonds.svg';
// import monopattini from '../assets/images/monopattini.png';
import PageLoading from '../common/components/elements/PageLoading';
import { getAvailableProducts } from '../features/auth/authActions';
import { fetchProfessionsList } from '../features/forms/formsActions';
// import { joyrideOptions } from '../common/utils/joyrideUtils';
// import { handleCallbackNewPreventivo } from '../common/utils/joyrideCallbacks';
// import { quoteSelectProductSteps } from '../common/utils/joyrideSteps';

const storage = new StorageService();
const ORDER_KEY = 'quoteProductOrder';
const ORDER_DAY_KEY = 'quoteProductOrderDay';

const PRODUCTS = [
  {
    id: 1,
    key: 'auto',
    title: 'Auto',
    isActiveKey: 'auto',
    onSelectProduct: 'auto',
    imageWhite: CarWhite,
    iamgeDark: Car,
    keywords: [
      'macchina', 'automobile', 'veicolo', 'rc auto', 'assicurazione auto',
      'polizza auto', 'targa',
    ],
  },
  {
    id: 13,
    key: 'ancillari_auto',
    title: 'Ancillari Auto',
    isActiveKey: 'ancillari_auto',
    onSelectProduct: 'ancillari-auto',
    iamgeDark: AncillariAuto,
    keywords: [
      'ancillari', 'garanzie accessorie auto', 'tutela legale auto',
      'infortuni conducente', 'cristalli', 'assistenza stradale',
      'furto incendio', 'kasko', 'collisione',
    ],
  },
  {
    id: 2,
    key: 'motorcycle',
    title: 'Moto',
    isActiveKey: 'motorcycle',
    onSelectProduct: 'motorcycle',
    imageWhite: MotoWhite,
    iamgeDark: Moto,
    keywords: [
      'motocicletta', 'scooter', 'motociclo', 'rc moto', 'assicurazione moto',
      'ciclomotore',
    ],
  },
  {
    id: 3,
    key: 'autocarro',
    title: 'Autocarro',
    isActiveKey: 'autocarro',
    onSelectProduct: 'autocarro',
    imageWhite: TruckWhite,
    iamgeDark: Truck,
    keywords: [
      'camion', 'furgone', 'mezzo pesante', 'veicolo commerciale',
      'autotrasporto', 'motrice', 'trasporto merci',
    ],
  },
  {
    id: 4,
    key: 'profession',
    title: 'Professionale',
    isActiveKey: 'profession',
    onSelectProduct: 'profession',
    imageWhite: JobImage,
    iamgeDark: JobImage,
    keywords: [
      'rc professionale', 'responsabilita civile professionale',
      'libero professionista', 'partita iva', 'studio professionale',
      'albo', 'ordine professionale', 'colpa professionale',
      // The full profession list (architetto, ingegnere, avvocato, ...) is
      // loaded at runtime from /form-data/professions and merged in here.
    ],
  },
  {
    id: 8,
    key: 'travel',
    title: 'Viaggi',
    isActiveKey: 'travel',
    onSelectProduct: 'travel',
    imageWhite: TripsWhite,
    iamgeDark: Trips,
    keywords: [
      'viaggio', 'vacanza', 'vacanze', 'estero', 'turismo',
      'assicurazione viaggio', 'annullamento viaggio', 'bagaglio',
      'assistenza in viaggio',
    ],
  },
  {
    id: 9,
    key: 'tutela_legale',
    title: 'Tutela Legale',
    isActiveKey: 'tutela_legale',
    onSelectProduct: 'tutela-legale',
    imageWhite: ProfessionalWhite,
    iamgeDark: Professional,
    keywords: [
      'spese legali', 'avvocato', 'assistenza legale', 'contenzioso',
      'difesa legale', 'vertenze', 'perizie',
    ],
  },
  {
    id: 11,
    key: 'casa',
    title: 'Casa',
    isActiveKey: 'casa',
    onSelectProduct: 'casa',
    imageWhite: HomeWhite,
    iamgeDark: Home,
    keywords: [
      'abitazione', 'immobile', 'fabbricato', 'appartamento', 'villa',
      'incendio casa', 'furto casa', 'rc capofamiglia', 'mutuo',
    ],
  },
  {
    id: 10,
    key: 'commercial',
    title: 'Impresa',
    isActiveKey: 'commercial',
    customOnSelect: (navigate) => navigate('quote-commercial'),
    imageWhite: commercialImageWhite,
    iamgeDark: commercialImage,
    keywords: [
      'azienda', 'attivita', 'attivita commerciale', 'negozio', 'ditta',
      'esercizio commerciale', 'multirischio azienda', 'business',
      'artigiano', 'capannone', 'ufficio',
    ],
  },
  {
    id: 12,
    key: 'salute',
    title: 'Salute',
    isActiveKey: 'salute',
    onSelectProduct: 'salute',
    imageWhite: Salute,
    iamgeDark: Salute,
    keywords: [
      'sanitaria', 'polizza sanitaria', 'rimborso spese mediche', 'ricovero',
      'assistenza sanitaria', 'visite specialistiche', 'diaria',
      'grandi interventi',
    ],
  },
  {
    id: 14,
    key: 'sanitaria_per_stranieri',
    title: 'Sanitaria per Stranieri',
    isActiveKey: 'sanitaria_per_stranieri',
    onSelectProduct: 'sanitaria-stranieri',
    imageWhite: Stranieri,
    iamgeDark: Stranieri,
    keywords: [
      'stranieri', 'permesso di soggiorno', 'cittadini stranieri', 'visto',
      'copertura sanitaria stranieri', 'immigrazione', 'ricongiungimento',
    ],
  },
  {
    id: 15,
    key: 'rc_professionale_sanita',
    title: 'Rc Professioni Sanitarie e Mediche',
    isActiveKey: 'rc_professionale_sanita',
    onSelectProduct: 'rc-professionale-sanita',
    imageWhite: Doctors,
    iamgeDark: Doctors,
    keywords: [
      'medico', 'dottore', 'infermiere', 'sanitario', 'professioni sanitarie',
      'ostetrica', 'odontoiatra', 'dentista', 'fisioterapista', 'psicologo',
      'colpa medica', 'malpractice', 'rc sanitaria', 'personale sanitario',
    ],
  },
  // {
  //   key: 'luce',
  //   title: 'Luce',
  //   isActiveKey: 'luce',
  //   onSelectProduct: 'luce',
  //   imageWhite: Luce,
  //   iamgeDark: Luce,
  //   alwaysAvailable: true,
  // },
  {
    id: 1000,
    key: 'public_employment',
    title: 'Pubblico Impiego',
    isActiveKey: 'public_employment',
    onSelectProduct: 'pubblico-impiego',
    imageWhite: PubblicoImpiego,
    iamgeDark: PubblicoImpiego,
    keywords: [
      'dipendente pubblico', 'statale', 'pubblica amministrazione',
      'responsabilita amministrativa', 'danno erariale', 'corte dei conti',
      'insegnante', 'docente', 'dirigente pubblico', 'forze dell ordine',
    ],
  },
  {
    id: 1001,
    key: 'malattia',
    title: 'Malattia',
    isActiveKey: 'malattia',
    onSelectProduct: 'malattia',
    imageWhite: Malattia,
    iamgeDark: Malattia,
    keywords: [
      'indennita malattia', 'diaria da ricovero', 'invalidita da malattia',
      'convalescenza', 'gesso',
    ],
  },
  {
    id: 1002,
    key: 'infortunio',
    title: 'Infortunio',
    isActiveKey: 'infortunio',
    onSelectProduct: 'infortunio',
    imageWhite: Infortunio,
    iamgeDark: Infortunio,
    keywords: [
      'infortuni', 'incidente', 'invalidita permanente', 'diaria da infortunio',
      'morte da infortunio', 'inabilita temporanea',
    ],
  },
  {
    id: 1003,
    key: 'condominio',
    title: 'Condominio',
    isActiveKey: 'condominio',
    onSelectProduct: 'condominio',
    imageWhite: condominio,
    iamgeDark: condominio,
    keywords: [
      'amministratore di condominio', 'parti comuni', 'fabbricato condominiale',
      'rc condominio', 'globale fabbricati', 'stabile',
    ],
  },
  {
    id: 1004,
    key: 'rc_famiglia',
    title: 'Rc Famiglia',
    isActiveKey: 'rc_famiglia',
    onSelectProduct: 'rc-famiglia',
    imageWhite: rcFamiglia,
    iamgeDark: rcFamiglia,
    keywords: [
      'responsabilita civile famiglia', 'capofamiglia', 'danni a terzi',
      'vita privata', 'cane', 'animali domestici', 'figli',
    ],
  },
  // {
  //   id: 1006,
  //   key: 'monopattini_elettrici',
  //   title: 'Monopattini Elettrici',
  //   isActiveKey: 'monopattini_elettrici',
  //   onSelectProduct: 'monopattini-elettrici',
  //   imageWhite: monopattini,
  //   iamgeDark: monopattini,
  // },
  {
    id: 1007,
    key: 'surety_bonds',
    title: 'Fideiussioni e Cauzioni',
    isActiveKey: 'surety_bonds',
    onSelectProduct: 'surety-bonds',
    iamgeDark: FideiussioniCauzioni,
    keywords: [
      'fideiussione', 'cauzione', 'garanzia', 'polizza fideiussoria',
      'appalto', 'gara', 'anticipazione', 'buona esecuzione',
    ],
  },
];

const dailyOrder = () => {
  const now = new Date();
  const todayKey = now.toISOString().slice(0, 10);

  const savedOrder = localStorage.getItem(ORDER_KEY);
  const savedDay = localStorage.getItem(ORDER_DAY_KEY);

  if (savedOrder && savedDay === todayKey && JSON.parse(savedOrder).length === PRODUCTS.length) {
    return JSON.parse(savedOrder);
  }

  const newOrder = PRODUCTS
    .map((p) => p.key)
    .sort(() => Math.random() - 0.5);

  localStorage.setItem(ORDER_KEY, JSON.stringify(newOrder));
  localStorage.setItem(ORDER_DAY_KEY, todayKey);

  return newOrder;
};

// Unicode combining diacritical marks (U+0300–U+036F), left over after NFD.
const COMBINING_MARKS = /[̀-ͯ]/g;

// Lowercase, strip accents and underscores, collapse whitespace so that
// "società" / "societa" / "PERSONALE_SANITARIO" all compare cleanly.
const normalizeText = (value = '') => value
  .toString()
  .toLowerCase()
  .normalize('NFD')
  .replace(COMBINING_MARKS, '')
  .replace(/_/g, ' ')
  .replace(/\s+/g, ' ')
  .trim();

// Build the searchable text for a product: its title + static keywords, plus
// the runtime-loaded profession list for the generic "Professionale" card.
const buildHaystack = (product, professionKeywords) => {
  const parts = [product.title, ...(product.keywords || [])];
  if (product.key === 'profession') {
    parts.push(...professionKeywords);
  }
  return normalizeText(parts.join(' '));
};

// Every search token must appear somewhere in the haystack (AND semantics),
// so "rc professionale" still matches "Rc Professioni Sanitarie e Mediche".
const productMatchesSearch = (product, normalizedQuery, professionKeywords) => {
  if (!normalizedQuery) return true;
  const haystack = buildHaystack(product, professionKeywords);
  return normalizedQuery
    .split(' ')
    .filter(Boolean)
    .every((token) => haystack.includes(token));
};

// Rank matches so the strongest ones lead: exact title > title contains >
// keyword-only match.
const searchScore = (product, normalizedQuery) => {
  if (!normalizedQuery) return 0;
  const title = normalizeText(product.title);
  if (title === normalizedQuery) return 3;
  if (title.includes(normalizedQuery)) return 2;
  return 1;
};

export default function Quote() {
  const [product, setProduct] = useState('');
  const [productOrder, setProductOrder] = useState(() => dailyOrder());
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  const [professionKeywords, setProfessionKeywords] = useState([]);
  const { loading, availableProducts } = useSelector(
    (store) => store.auth.user_products,
  );
  const navigate = useNavigate();
  const navigateToProductForm = (product) => {
    setProduct(product);
    if (product === 'auto' || product === 'autocarro') {
      storage.removeVehicleDriverData();
      storage.removeVehicleOwnerData();
      storage.removeVehicleQuoteAnswers();
      storage.removeBersani();
    } else if (product === 'profession') {
      storage.removeSelectedProfession();
    }

    if (product === 'motorcycle') {
      storage.removeMotoQuoteAnswers();
    }

    if (product === 'motorcycle') {
      storage.removeMotoQuoteAnswers();
    }

    if (product === 'metlife') {
      navigate('/quote/metlife');
    } else {
      navigate(`/quote/${product}`);
    }
    if (product === 'travel') {
      storage.removeTravelData();
      navigate('/quote/travel');
    }

    if (product === 'casa') {
      // storage.removeTravelData();
      navigate('/quote/casa');
    }
  };

  useEffect(() => {
    getAvailableProducts();
  }, []);

  // Enrich the "Professionale" card so that typing a profession
  // (e.g. "architetto") surfaces it. Falls back to the static keywords
  // on failure.
  useEffect(() => {
    let active = true;
    (async () => {
      const professions = await fetchProfessionsList();
      if (!active) return;
      const keywords = professions
        .flatMap((p) => [p?.name, p?.code])
        .filter(Boolean);
      setProfessionKeywords(keywords);
    })();
    return () => {
      active = false;
    };
  }, []);

  // const {
  //   setState,
  //   state: { run, showBeacon },
  // } = useTourContext();

  // useEffect(() => {
  //   if (localStorage.getItem('selectProduct') === 'done') {
  //     setState({ run: false });
  //   } else {
  //     setTimeout(() => {
  //       setState({ run: true });
  //     }, 1500);
  //   }
  // }, [localStorage.getItem('selectProduct')]);

  // const fireNewQuoteTour = () => {
  //   localStorage.removeItem('selectProduct');
  //   setState({ run: true, tourActive: true });
  // };

  // let availableProducts = [1, 2, 3, 4, 5, 6, 8, 9];

  // const user = storage.getUser();
  // if (user.available_products !== undefined) {
  //   availableProducts = user.available_products;
  // }

  const isAvailable = (productId) => availableProducts.includes(productId);

  useEffect(() => {
    setProductOrder(dailyOrder());
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [searchTerm]);

  if (loading) {
    return <PageLoading />;
  }

  const normalizedSearch = normalizeText(debouncedSearchTerm);

  const orderedProducts = productOrder
    .map((key) => PRODUCTS.find((product) => product.key === key));

  const renderProducts = (product) => (product.alwaysAvailable || isAvailable(product.id))
    && productMatchesSearch(product, normalizedSearch, professionKeywords);

  let visibleProducts = orderedProducts.filter((item) => item && renderProducts(item));

  if (normalizedSearch) {
    visibleProducts = [...visibleProducts].sort(
      (a, b) => searchScore(b, normalizedSearch) - searchScore(a, normalizedSearch),
    );
  }

  const getOnSelect = (item) => {
    if (item.customOnSelect) {
      return () => item.customOnSelect(navigate);
    }
    return () => navigateToProductForm(item.onSelectProduct || item.key);
  };

  return (
    <div className="quote">
      {/* <Joyride
        steps={quoteSelectProductSteps}
        continuous
        showBeacon={showBeacon}
        locale={{
          back: 'Indietro',
          close: 'Chiudi',
          last: 'Fine',
          next: 'Prossima',
          open: 'Apri il modale',
          restart: 'Riavvia il tour ',
          skip: 'Salta',
        }}
        styles={{
          options: joyrideOptions,
          buttonNext: {
            backgroundColor: '#00a651',
            outline: 'none',
          },
          buttonBack: {
            color: '#00a651',
            outline: 'none',
          },
          beaconInner: {
            backgroundColor: '#00a651',
          },
          beaconOuter: {
            borderColor: '#00a651',
            backgroundColor: 'rgba(68 , 154 , 71, 0.4)',
          },
          buttonSkip: {
            outline: 'none',
          },
          buttonClose: {
            outline: 'none',
          },
        }}
        run={run}
        callback={(data) => handleCallbackNewPreventivo(data, quoteSelectProductSteps, setState)}
        showSkipButton
        showProgress
      />

      <div className="d-flex justify-content-end align-items-end">
        {localStorage.getItem('selectProduct') === 'done' && (
          <div style={{ cursor: 'pointer' }} onClick={() => fireNewQuoteTour()}>
            <button className="btn btn-success btn-sm text-white px-3">Tutorial</button>
          </div>
        )}
      </div> */}

      <div className="quote-group">
        <div className="quote-h1 text-center">
          <h1>NUOVO PREVENTIVO</h1>
        </div>
        <div className="quote-h6 mb-2">
          <h6>Cosa vuoi proteggere?</h6>
        </div>
      </div>
      <div className="container select-product-search">
        <div className="product-search-input mx-auto">
          <img src={SearchIcon} alt="" className="product-search-icon" width="16" height="16" />
          <input
            type="text"
            className="product-search-field"
            placeholder="Cerca un prodotto..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {searchTerm && (
            <button
              type="button"
              className="product-search-clear"
              aria-label="Cancella ricerca"
              onClick={() => setSearchTerm('')}
            >
              &times;
            </button>
          )}
        </div>
      </div>
      <div className="container text-center select-product-one">
        <div className="row justify-content-center g-2 g-md-3 ">
          {visibleProducts.map((item) => {
            const activeKey = item.onSelectProduct || item.key;

            return (
              <ProductCard
                key={item.key}
                title={item.title}
                isActive={product === activeKey}
                onSelect={getOnSelect(item)}
                imageWhite={item.imageWhite}
                iamgeDark={item.iamgeDark}
              />
            );
          })}
        </div>
        {normalizedSearch && visibleProducts.length === 0 && (
          <div className="text-start mt-4">
            <p className="text-muted">
              Nessun prodotto trovato per &quot;
              {debouncedSearchTerm.trim()}
              &quot;. Prova a chiedere all&apos;IA:
            </p>
            <AiProducts
              showTitle={false}
              placeholderMessage="Quale prodotto cerchi?"
            />
          </div>
        )}
      </div>
    </div>
  );
}
